import React, { useCallback, useEffect, useState } from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import { Checkbox, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { MDBInput } from "mdb-react-ui-kit";
import axios from "axios";
import PospFormImage from '../../../src/Assets/Images/PospForm.svg';
import apiUrls from "../../Api/MainApi";
import "./PospRegistrationComp/index.css"
import debounce from 'lodash.debounce';
import Loader from "../../Layout/Loader/Loader";

const PospForm = () => {
    const navigate = useNavigate();
    const [checked, setChecked] = useState(true);
    const [formData, setFormData] = useState({ fullName: "", email: "", Pincode: null, mobileNumber: "" });
    const [errors, setErrors] = useState({});
    const [loading, setloading] = useState(false);
    const [searchTextPincode, setSearchTextPincode] = useState("");
    const [PincodeOptions, setPincodeOptions] = useState([]);
    const debouncedSetSearchTextPincode = useCallback(debounce(setSearchTextPincode, 300), []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const onChange = (e) => {
        setChecked(e.target.checked);
    };
    const handleSearchPincode = (value) => {
        debouncedSetSearchTextPincode(value);
    };
    useEffect(() => {
        const fetchStateOptions = async () => {
            try {
                const response = await axios.post(apiUrls.GetPincodeDropDownList, { SearchText: searchTextPincode });
                setPincodeOptions(response.data.data || []);
                console.log(response, "response")
            } catch (error) {
                console.error('Error fetching State options:', error);
            }
        };
        fetchStateOptions();
    }, [searchTextPincode]);

    const handlePincodeChange = (value) => {
        setFormData(prevData => ({
            ...prevData,
            Pincode: value
        }));
        setSearchTextPincode('');
    };


    const validate = () => {
        const newErrors = {};
        if (!formData.fullName.trim()) {
            newErrors.fullName = "Please enter your full name.";
        }
        if (!checked) {
            newErrors.checkbox = "Please agree to the terms and conditions.";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Please enter your email address.";
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email.trim())) {
                newErrors.email = "Please enter a valid email address.";
            }
        }

        // if (!formData.Pincode.trim()) {
        //     newErrors.Pincode = "Please enter your Pincode.";
        // } else if (formData.Pincode.trim().length !== 6 || isNaN(formData.Pincode.trim())) {
        //     newErrors.Pincode = "Please enter a valid 6-digit Pincode.";
        // }
        if (!formData.Pincode) {
            newErrors.Pincode = "Please enter your Pincode.";
        }

        if (!formData.mobileNumber.trim()) {
            newErrors.mobileNumber = "Please enter your mobile number.";
        } else {
            const mobileRegex = /^[0-9]{10}$/;
            if (!mobileRegex.test(formData.mobileNumber.trim())) {
                newErrors.mobileNumber = "Please enter a valid 10-digit mobile number.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        if (validate()) {
            const fullNameArray = formData.fullName.trim().split(' ');
            const firstName = fullNameArray[0];
            const lastName = fullNameArray[fullNameArray.length - 1];

            const FormData = {
                Fname: firstName,
                Lname: lastName,
                MobileNo: formData.mobileNumber,
                EmailID: formData.email,
                Pincode: formData.Pincode,
                isActive: true,
                Createdby: 1
            };
            try {
                setloading(true)
                const response = await axios.post(apiUrls.InsertPOSPRequestMaster, FormData);
                console.log(response)
                console.log(response.data.data, "line ws83");
                if (response.data.data.IsUser === false) {
                    let pospId;
                    if (response.data.data.IsRegistered === false) {
                        pospId = response.data.data.POSPID;
                    } else if (response.data.data.IsRegistered === true) {
                        pospId = response.data.data.POSPID;
                        navigate(`${process.env.PUBLIC_URL}/posp/registration`);
                    }

                    if (pospId) {
                        sessionStorage.setItem("pospid", pospId);
                        navigate(`${process.env.PUBLIC_URL}/posp/registration`);
                    }
                }
                else {
                    window.location.href = 'https://buypolicynow.com/BPNPOS/login';
                }
            } catch (error) {
                console.error("Error submitting form", error);
            } finally {
                setloading(false)
            }
        }
    };
    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return (

        <>
            {/* <style>
                {`
                    .ant-select-selection-placeholder {
                            font-weight: normal;
                            color: #666666;
                    }
                `}
            </style> */}
            <div className="container mx-auto h-screen">
                <div className="row d-flex justify-content-center mb-4 pb-5" style={{ width: "100%" }}>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 pospform-img">
                            <div className="d-flex justify-content-center">
                                <img src={PospFormImage} className="posp-banner" alt="posp-registration" />
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12 d-flex justify-content-center gap-4 align-item-center">
                            <Card className="d-flex justify-content-center pospform-main-card">

                                {(!loading) && <Card.Title>
                                    <h4 className="text-center pt-3 pb-2" style={{ color: "rgb(113, 101, 164)" }}>
                                    Achieve PoSP Status
                                    </h4>
                                </Card.Title>}
                                {(loading) && <Loader />}
                                {(!loading) &&
                                    <Form onSubmit={handleSubmit} className="posp-form" autoComplete="off">
                                        <Form.Group controlId="fullName">
                                            <MDBInput
                                                size="lg"
                                                type="text"
                                                label="Enter Full Name"
                                                name="fullName"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                // required
                                                className="posp-form-input"
                                            />
                                            {errors.fullName && <div style={{ color: "red" }}>{errors.fullName}</div>}
                                        </Form.Group>

                                        <Form.Group controlId="email">
                                            <MDBInput
                                                size="lg"
                                                type="email"
                                                label="Enter Email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                // required
                                                className="posp-form-input"
                                            />
                                            {errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
                                        </Form.Group>

                                        <Form.Group controlId="Pincode" style={{ width: "78%" }}>
                                            {/* <MDBInput
                                                size="lg"
                                                type="text"
                                                label="Enter Pincode"
                                                name="Pincode"
                                                value={formData.Pincode}
                                                onChange={handleChange}
                                                className="posp-form-input"
                                                minLength="6"
                                                maxLength="6"
                                            /> */}
                                            <Select
                                                name="Pincode"
                                                value={formData.Pincode}
                                                onChange={handlePincodeChange}
                                                onSearch={handleSearchPincode}
                                                options={PincodeOptions.map(Pincode => ({ value: Pincode.id, label: Pincode.name }))}
                                                placeholder="Select Pincode"
                                                showSearch
                                                filterOption={filterOption}
                                                style={{ width: "100%", height: "45px" }}  // Blue color with fontWeight 500
                                            />
                                            {errors.Pincode && <div style={{ color: "red" }}>{errors.Pincode}</div>}
                                        </Form.Group>

                                        <Form.Group controlId="mobileNumber">
                                            <MDBInput
                                                size="lg"
                                                type="tel"
                                                label="Enter Mobile Number"
                                                name="mobileNumber"
                                                value={formData.mobileNumber}
                                                onChange={handleChange}
                                                pattern="[0-9]{10}"
                                                minLength="10"
                                                maxLength="10"
                                                // required
                                                className="posp-form-input"
                                            />
                                            {errors.mobileNumber && <div style={{ color: "red" }}>{errors.mobileNumber}</div>}
                                        </Form.Group>

                                        <Button type="submit" className="posp-form-btn">
                                            Get Started
                                        </Button>

                                        <Form.Group className="mb-3 d-flex gap-2" id="formGridCheckbox">
                                            <Form.Check name="checkbox" type="checkbox" defaultChecked={true} onChange={onChange} />
                                            <div className="agree-class-div">
                                                <p className="d-flex " style={{ fontSize: "14px", margin: "0" }}>
                                                    I agree to
                                                    <span style={{ textDecoration: "underline" }}>
                                                        <Link to={`${process.env.PUBLIC_URL}/terms-and-conditions`} target="blank">Terms & Conditions</Link>
                                                    </span>
                                                </p>
                                                <div>

                                                    {errors.checkbox && <div style={{ color: "red" }}>{errors.checkbox}</div>}
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </Form>}
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PospForm;
